<template>
	<div>
		<h2>Umowa nr {{project.agreementNumber}}</h2>
		<h2>Data podpisania: {{displayDate(project.agreementSignDate)}}</h2>

		<v-dialog
			v-model="showDialog"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn class="mt-3" v-on="on">{{getAgreementButtonLabel}}</v-btn>
			</template>
			<v-card>
				<v-form ref="form">
					<v-card-title
						class="headline"
						primary-title
					>
						Pobierz umowę
					</v-card-title>
					<v-card-text>
						<h3>Umowa:</h3>
						<div style="cursor:pointer">
							<strong>{{agreementName}}</strong>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on" class="ma-0 v-btn-mini" @click="downloadAgreement">
										<v-icon class="margin: 0px" small>cloud_download</v-icon>
									</v-btn>
								</template>
								<span>Pobierz dokument</span>
							</v-tooltip>
							<v-tooltip top v-if="hasProjectPanelSupervisorModificationAccess()">
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on" class="mx-0 v-btn-mini" @click="replaceAgreement">
										<v-icon class="margin: 0px" small>swap_horiz</v-icon>
									</v-btn>
								</template>
								<span>Podmień dokument</span>
							</v-tooltip>
						</div>
						<input type="file" v-show="false" ref="agreementFile" id="agreementFile"
							:accept="acceptedFiles"
							v-on:change="replaceFile('agreement')">
						<div v-if="attachmentList.length>0">
							<h3 class="mt-3">Załączniki:</h3>
							<div v-for="(item, index) in attachmentList" :key="index">
								<strong>{{item.fileName}}</strong>
								<v-tooltip top>
									<template v-slot:activator="{ on }">
										<v-btn x-small icon v-on="on" class="mx-0 v-btn-mini"
											@click="downloadAttachment(item)">
											<v-icon class="margin: 0px" small>cloud_download</v-icon>
										</v-btn>
									</template>
									<span>Pobierz dokument</span>
								</v-tooltip>
								<v-tooltip top v-if="hasProjectPanelSupervisorModificationAccess()">
									<template v-slot:activator="{ on }">
										<v-btn x-small icon v-on="on" class="mx-0 v-btn-mini"
											@click="deleteAttachment(item)">
											<v-icon class="margin: 0px" small color="red">delete</v-icon>
										</v-btn>
									</template>
									<span>Usuń załącznik</span>
								</v-tooltip>
							</div>
						</div>
						<input type="file" v-show="false" ref="attachmentFile" id="attachmentFile"
							:accept="acceptedFiles"
							v-on:change="replaceFile('attachment')">
						<input type="file" v-show="false" ref="newAttachment" id="newAttachment"
							:accept="acceptedFiles"
							v-on:change="uploadAttachment">
					</v-card-text>
					<v-card-actions>
						<v-spacer/>
						<v-btn v-if="hasProjectPanelSupervisorModificationAccess()"
							@click="$refs.newAttachment.click()">
							Dodaj załącznik
						</v-btn>
						<v-btn @click="showDialog = false">
							Zamknij
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {Dates} from "../../../../utils/Dates";
	import {Files} from "../../../../utils/Files";
	import {Project} from "../../../../api/generated/Project";

	export default {
		name: "AgreementData",
		mixins: [Dates, Files],

		data: function () {
			return {
				showDialog: false,
				attachmentList: [],
				agreementName: "",
				hashToReplace: ""
			};
		},

		computed: {
			getAgreementButtonLabel () {
				if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
					return "Pobierz lub edytuj umowę";
				}
				return "Pobierz umowę";
			}
		},

		methods: {
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			downloadAgreement() {
				this.downloadFileAsBlob(this, this.getProjectAgreement(this.$route.params.projectId), this.agreementName);
			},
			getAttachmentList() {
				Project.getAgreementAndAttachmentsList(this, this.$route.params.projectId,
					onSuccess => {
						this.agreementName = onSuccess.agreementFileName;
						this.attachmentList = onSuccess.attachmentList;
					});
			},
			replaceAgreement () {
				this.$refs.agreementFile.click();
			},
			deleteAttachment (item) {
				Project.deleteAgreementAttachment(this, this.$route.params.projectId, item.hash,
					successResponse => {
						this.$messagesBus.$emit("success", "Załącznik został usunięty", successResponse);
						this.getAttachmentList();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć załącznika", errorResponse);
					});
			},
			async replaceFile (type) {
				let formData = new FormData();
				let fileHash;
				let isAgreement;
				if (type === "agreement") {
					if (!this.$refs.agreementFile.files[0]) {
						return;
					}
					if (this.hasIncorrectFilesExtension(this.$refs.agreementFile.files)) {
						Files.methods.clearFileInput('agreementFile');
            this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
                "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
            return;
					}
					let validSize = await Files.methods.validateFilesSize(this, this.$refs.agreementFile.files);
					if (!validSize) {
						Files.methods.clearFileInput('agreementFile');
						return;
					}
					isAgreement = "true";
					fileHash = "";
					formData.append("file", this.$refs.agreementFile.files[0]);
				} else {
					if (!this.$refs.attachmentFile.files[0]) {
						return;
					}
					if (this.hasIncorrectFilesExtension(this.$refs.attachmentFile.files)) {
						Files.methods.clearFileInput('attachmentFile');
            this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
                "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
            return;
					}
					let validSize = await Files.methods.validateFilesSize(this, this.$refs.attachmentFile.files);
					if (!validSize) {
						Files.methods.clearFileInput('attachmentFile');
						return;
					}
					isAgreement = "false";
					fileHash = this.hashToReplace;
					formData.append("file", this.$refs.attachmentFile.files[0]);
				}
				await this.$http.put(process.env.VUE_APP_API_URL + "/project/replace-agreement-file?projectId="
					.concat(this.$route.params.projectId)
					.concat("&hash=").concat(fileHash)
					.concat("&agreement=").concat(isAgreement), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.getAttachmentList();
			},
			async uploadAttachment () {
				if (this.hasIncorrectFilesExtension(this.$refs.newAttachment.files)) {
					Files.methods.clearFileInput('newAttachment');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validSize = await Files.methods.validateFilesSize(this, this.$refs.newAttachment.files);
				if (!validSize) {
					Files.methods.clearFileInput('newAttachment');
					return;
				}
				let formData = new FormData();
				formData.append("file", this.$refs.newAttachment.files[0]);
				await this.$http.post(process.env.VUE_APP_API_URL + "/project/agreement-file?projectId="
					.concat(this.$route.params.projectId), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.getAttachmentList();
			},
			downloadAttachment(item) {
				this.downloadFileAsBlob(this, this.getProjectFile(item.hash), item.fileName);
			},
		},

		props: {
			project: {
				type: Object,
			},
		},

		watch: {
			showDialog: function (val) {
				if (val === true) {
					this.getAttachmentList();
				}
			}
		},

	};
</script>

<style scoped>
	.v-btn-mini {
		height: auto;
		width: auto;
		padding-left: 10px;
	}
</style>
